module.exports = __webpack_public_path__ + "static/media/xray-training-medial-flex2.f184fc4a.png";